import React, { memo } from 'react';
import {
  arrayOf, bool, func, number, shape, string,
} from 'prop-types';
import * as S from './styles';

function Table(props) {
  const {
    label,
    id,
    questionIndex,
    screenerRatingPercentage,
    question,
    handleOpenModalAndSetAudienceChange,
    handleQuestionOptionType,
  } = props;

  return (
    <>
      <S.Header>
        <S.Row>
          <S.HeaderColumn>
            <S.Text.Bold>
              {`Screener Question ${questionIndex + 1}`}
            </S.Text.Bold>
          </S.HeaderColumn>
          <S.HeaderColumn>
            <S.Text.Bold>
              {label}
            </S.Text.Bold>
          </S.HeaderColumn>
        </S.Row>
      </S.Header>
      <S.Body>
        <S.RowTable>
          <S.Column>
            {screenerRatingPercentage ? (
              <S.ColoredQuestionRating percentage={screenerRatingPercentage}>
                {`${screenerRatingPercentage} of participants qualified`}
              </S.ColoredQuestionRating>
            ) : (
              <S.FieldQuestionRate>
                Pass rates unavailable
                <S.LearnMoreLink
                  href="http://help.playbookux.com/en/articles/8225730-screen-survey-pass-rates"
                  target="_blank"
                >
                  Learn more
                </S.LearnMoreLink>
              </S.FieldQuestionRate>
            )}
            <S.EditNumberButton
              onClick={() => handleOpenModalAndSetAudienceChange(id, screenerRatingPercentage, 'question')}
            >
              Edit number
            </S.EditNumberButton>
          </S.Column>
          <S.Column style={{ padding: '1em' }}>
            {question?.questionOptions?.map(({
              id: idQuestionOption, qualify, disqualify, label: labelQuestionOption, optionRatingPercentage,
            }, index) => (
              <S.ContainerAnswerButton key={idQuestionOption}>
                <S.TextQuestionOption>
                  {`Answer ${index + 1}: ${labelQuestionOption} `}
                  {handleQuestionOptionType(disqualify, qualify)}
                </S.TextQuestionOption>
                <S.RattingOption>
                  {!optionRatingPercentage ? '0%' : optionRatingPercentage}
                </S.RattingOption>
                <S.EditNumberButton
                  onClick={() => handleOpenModalAndSetAudienceChange(
                    idQuestionOption,
                    optionRatingPercentage,
                    'questionOption',
                  )}
                >
                  Edit number
                </S.EditNumberButton>
              </S.ContainerAnswerButton>
            ))}
          </S.Column>
        </S.RowTable>
      </S.Body>
    </>
  );
}

Table.propTypes = {
  label: string.isRequired,
  id: string.isRequired,
  questionIndex: number.isRequired,
  screenerRatingPercentage: string,
  question: shape({
    questionOptions: arrayOf(shape({
      id: string,
      label: string,
      qualify: bool,
      disqualify: bool,
      optionRatingPercentage: string,
    })),
  }),
  handleOpenModalAndSetAudienceChange: func.isRequired,
  handleQuestionOptionType: func.isRequired,
};

Table.defaultProps = {
  screenerRatingPercentage: '',
  question: {
    questionOptions: [],
  },
};

export default memo(Table);
